import React, { useEffect } from "react";
import { useAltMeter } from "@/hooks/useAltMeter";
import { GradientProgressBar } from "./GradientProgressBar";

export function AltMeter() {
  const { data } = useAltMeter();

  const [prcValue, setPrcValue] = React.useState(0);
  useEffect(() => {
    if (!data) {
      setPrcValue(0);
      return;
    }
    const value = data["15m"];
    if (!value) {
      setPrcValue(0);
      return;
    }
    const prcValue = 100 - Math.round(((value + 5) / 10) * 100);

    setPrcValue(prcValue);
  }, [data]);

  return <GradientProgressBar value={prcValue} min={0} max={100} />;
}
